/* Press feedback and haptics for controls on the modern pages.
 *
 * 1. Press state. The stylesheets shrink a control slightly while it is pressed. :active alone is not enough
 *    on iPhone: Safari applies it late or not at all on a touch, and a long press hands the touch to the
 *    system instead. So this adds .is-pressed on pointerdown and removes it when the pointer lifts, is
 *    cancelled (a scroll starts) or the page is left. The CSS styles :active and .is-pressed the same way,
 *    so a mouse, a keyboard and a script-less page still get the :active version.
 *
 *    A product card waits 90ms before it shows the press, so beginning a scroll with a finger on a card
 *    does not make the card flinch; buttons respond at once.
 *
 * 2. Haptic tick, on the taps that choose or add something - not on every link. This is navigator.vibrate,
 *    which Android has and iPhone does not: Safari gives web pages no vibration API. A hidden native switch
 *    was tried as a workaround for iPhone and produced nothing on the device it was tested on, so it was
 *    removed rather than left as dead code.
 *
 * Delegated from document, so controls added later (the quick-add sheet, a re-rendered drawer) are covered.
 */
(() => {
  if (window.__msPress) return;
  window.__msPress = true;

  const PRESSABLE = '.ms-btn, .ms-icon-btn, .ms-card__add, .ms-fit__size, .ms-filter-toggle, .ms-quick-add__chip, .ms-quick-add__submit, .ms-quick-add__close, .mstore-pdp__choice-label, .mstore-pdp__thumb, .mstore-pdp__add-button, .mstore-sticky-atc__button, .mstore-addon__add';
  const DELAYED = '.ms-card__link';
  const HAPTIC = '.ms-card__add, .ms-quick-add__chip, .ms-quick-add__submit, .mstore-pdp__choice-label, .mstore-pdp__add-button, .mstore-sticky-atc__button, .mstore-addon__add';

  let pressed = null;
  let pending = 0;
  const release = () => {
    clearTimeout(pending);
    if (!pressed) return;
    pressed.classList.remove('is-pressed');
    pressed = null;
  };

  document.addEventListener('pointerdown', (event) => {
    release();
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    const target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    const el = target.closest(PRESSABLE);
    if (el) {
      if (el.disabled) return;
      pressed = el;
      el.classList.add('is-pressed');
      return;
    }
    const slow = target.closest(DELAYED);
    if (!slow) return;
    pressed = slow;
    pending = setTimeout(() => { if (pressed === slow) slow.classList.add('is-pressed'); }, 90);
  }, { passive: true });
  ['pointerup', 'pointercancel', 'dragstart', 'contextmenu'].forEach((type) => document.addEventListener(type, release, { passive: true }));
  window.addEventListener('blur', release);
  window.addEventListener('pagehide', release);
  window.addEventListener('pageshow', release);

  let lastTick = 0;
  const tick = () => {
    const now = Date.now();
    if (now - lastTick < 60) return; // a label click also fires a click on its input
    lastTick = now;
    try {
      if (typeof navigator.vibrate === 'function') navigator.vibrate(8);
    } catch (error) {
      /* feedback only: never let it break the tap */
    }
  };

  document.addEventListener('click', (event) => {
    const el = event.target && event.target.closest ? event.target.closest(HAPTIC) : null;
    if (el && !el.disabled) tick();
  }, { passive: true });
})();
